export default __webpack_public_path__ + "static/media/horse.56d6ead7.png";